import styles from './styles.module.scss';
import { InlineSvg } from 'components/svg';
import { FC, MouseEvent } from 'react';
import { useIframeDialogStore } from 'widgets/iframe-dialog';

export const ActionPanel: FC<{ soHeaderId?: number; technicianJobId?: number }> = ({ soHeaderId, technicianJobId }) => {
  const { open: openDigitalWipModal } = useIframeDialogStore();
  const openDigitalWip = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    openDigitalWipModal(`/digital-wip-view/${soHeaderId}`);
  };

  return (
    <div className={styles.container}>
      <div>
        <a href="#" className={styles.linkBlock} onClick={openDigitalWip}>
          <InlineSvg path="/media/icons/custom/cif-open.svg" className="me-1" />
          Digital WIP
        </a>
      </div>

      <div>
        <a href={'#'} target="_blank" rel="noopener noreferrer" className={styles.linkBlock}>
          <InlineSvg path="/media/icons/duotune/files/fil003.svg" className="me-1" />
          Check In PDF
        </a>
      </div>
      <div>
        <a href={'#'} target="_blank" rel="noopener noreferrer" className={styles.linkBlock}>
          <InlineSvg path="/media/icons/duotune/files/fil003.svg" className="me-1" />
          Technician Job PDF
        </a>
      </div>
    </div>
  );
};
